export const quickLinkItems = [
  { name: "Home" },
  { name: "Products" },
  { name: "About" },
  { name: "Features" },
  { name: "Contact" },
];

export const resourcesItems = [
  { name: "Download Whitepapper" },
  { name: "Smart Token" },
  { name: "Blockchain Explorer" },
  { name: "Crypto API" },
  { name: "Interest" },
];
